import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AracDetay, Musteri } from '@nero/shared';
import { para, plakaGoster, plakaNormalle, tarihGoster } from '@nero/shared';
import { ApiHatasi, api, useEylem, useVeri } from '../lib/veri.js';
import { useOturum } from '../lib/oturum.js';
import { useBildirim } from '../lib/bildirim.js';
import { sorgu } from '../lib/api.js';
import { BosDurum, HataKutusu, Kart, SayfaBaslik, UyariSerit, Yukleniyor } from '../bilesenler/temel.js';
import { Arama, Girdi, MetinAlani, ParaGirdi, Secim, SecenekSerit } from '../bilesenler/form.js';
import { Pencere } from '../bilesenler/Pencere.js';
import { Simge } from '../bilesenler/Simge.js';

export function Musteriler() {
  const [gorunum, setGorunum] = useState<'musteri' | 'arac'>('musteri');
  const [arama, setArama] = useState('');
  const [yeniAcik, setYeniAcik] = useState(false);
  const git = useNavigate();
  const { yetkili } = useOturum();
  const finansGor = yetkili('kasa.goruntule');

  const yol = gorunum === 'musteri' ? `/musteriler${sorgu({ q: arama })}` : `/araclar${sorgu({ q: arama })}`;
  const { veri, yukleniyor, hata, yenile } = useVeri<Musteri[] | AracDetay[]>(yol);

  /* Yazılan metin plaka gibi mi görünüyor? "27ABC123" ve "27 abc 123"
     aynı şeydir; harf+rakam karışımı ve en az dört karakter aranır.
     Sadece isim yazan biri için bu dal hiç açılmaz. */
  const arananPlaka = plakaNormalle(arama);
  const plakaAramasi = arananPlaka.length >= 4
    && /[0-9]/.test(arananPlaka) && /[A-Z]/.test(arananPlaka);

  return (
    <div className="sayfa">
      <SayfaBaslik baslik="Müşteriler" alt="Müşteriler ve araçları aynı yerde">
        {yetkili('musteri.duzenle') && (
          <button className="btn btn-birincil" onClick={() => setYeniAcik(true)}>
            <Simge ad="arti" className="simge" /> Yeni müşteri
          </button>
        )}
      </SayfaBaslik>

      <div className="satir" style={{ marginBottom: 'var(--b4)', flexWrap: 'wrap', gap: 'var(--b3)' }}>
        <SecenekSerit
          deger={gorunum}
          secenekler={[{ deger: 'musteri', ad: 'Müşteriler' }, { deger: 'arac', ad: 'Araçlar' }]}
          onChange={setGorunum}
        />
        <Arama
          deger={arama} onChange={setArama}
          yerTutucu={gorunum === 'musteri'
            ? 'Müşteri, telefon veya plaka ara…'
            : 'Plaka, marka, motor kodu…'}
        />
      </div>

      <Kart>
        {hata ? (
          <div className="kart-govde"><HataKutusu hata={hata} yenile={yenile} /></div>
        ) : yukleniyor ? (
          <div className="kart-govde"><Yukleniyor /></div>
        ) : !veri || veri.length === 0 ? (
          <div className="kart-govde">
            {/* PLAKA BULUNAMADI ≠ HATA.
                Sorgu çalıştı, kayıt yok. Personelin tezgâhtaki bir sonraki
                adımı bellidir: bu aracı sisteme almak. Yazdığı plaka yeni
                kayıt penceresine taşınır, ikinci kez yazmaz.
                Gerçek ağ/API hatası bu daldan geçmez — yukarıdaki
                `HataKutusu` onu ayrı gösterir. */}
            <BosDurum
              simge={gorunum === 'musteri' ? 'musteri' : 'arac'}
              baslik={plakaAramasi ? 'Bu plaka sistemde kayıtlı değil'
                : arama ? 'Sonuç bulunamadı' : 'Henüz kayıt yok'}
              aciklama={plakaAramasi
                ? `${plakaGoster(arananPlaka)} için kayıt bulunamadı. Yeni müşteri ve aracını şimdi ekleyebilirsiniz.`
                : arama ? 'İsim, telefon ya da plaka ile deneyin.'
                  : 'İş emri açtığınızda müşteri ve araç otomatik kaydedilir.'}
            />
            {plakaAramasi && yetkili('musteri.duzenle') && (
              <div className="satir" style={{ justifyContent: 'center', marginTop: 'var(--b4)' }}>
                <button className="btn btn-birincil" onClick={() => setYeniAcik(true)}>
                  <Simge ad="arti" className="simge" /> Yeni müşteri ve araç oluştur
                </button>
              </div>
            )}
          </div>
        ) : gorunum === 'musteri' ? (
          <div className="tablo-sarma">
            <table className="tablo">
              <thead>
                <tr>
                  <th>Ad</th><th>Telefon</th><th>Son işlem</th><th>Son not</th>
                  {finansGor && <th className="sag">Toplam harcama</th>}
                  <th />
                </tr>
              </thead>
              <tbody>
                {(veri as Musteri[]).map((m) => (
                  <tr key={m.id} className="tiklanabilir" onClick={() => git(`/musteriler/${m.id}`)}>
                    <td>
                      <div className="ana">{m.ad}</div>
                      {m.eposta && <div className="ikincil">{m.eposta}</div>}
                    </td>
                    <td className="ikincil">{m.telefon || '—'}</td>
                    <td className="ikincil dar">{m.son_islem_tarihi ? tarihGoster(m.son_islem_tarihi) : '—'}</td>
                    <td className="ikincil" style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {m.son_not || '—'}
                    </td>
                    {finansGor && <td className="sag para">{para(m.toplam_harcama ?? 0)}</td>}
                    <td className="dar"><Simge ad="ok-sag" boyut={14} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="tablo-sarma">
            <table className="tablo">
              <thead><tr><th>Plaka</th><th>Araç</th><th>Motor</th><th>Müşteri</th><th /></tr></thead>
              <tbody>
                {(veri as AracDetay[]).map((a) => (
                  <tr key={a.id} className="tiklanabilir" onClick={() => git(`/musteriler/${a.musteri_id}`)}>
                    <td className="ana">{plakaGoster(a.plaka)}</td>
                    <td className="ikincil">{[a.marka, a.model].filter(Boolean).join(' ') || '—'}</td>
                    <td className="ikincil">{[a.motor, a.motor_kodu].filter(Boolean).join(' · ') || '—'}</td>
                    <td className="ikincil">{a.musteri_ad}</td>
                    <td className="dar"><Simge ad="ok-sag" boyut={14} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Kart>

      {yeniAcik && (
        <MusteriPenceresi
          /* Aranan plaka forma taşınır: personel aynı plakayı ikinci kez
             yazmak zorunda kalmasın. */
          ilkPlaka={plakaAramasi ? arananPlaka : ''}
          kapat={() => setYeniAcik(false)}
          kaydedildi={(id) => { setYeniAcik(false); git(`/musteriler/${id}`); }}
        />
      )}
    </div>
  );
}

/**
 * YENİ MÜŞTERİ — İLK ARACIYLA BİRLİKTE.
 *
 * Atölye akışı "önce müşteri, sonra araç" değildir: araç gelir, plakası
 * yazılır. Eskiden müşteri kaydedilip sonra detayına girip ayrıca araç
 * eklemek gerekiyordu; personel çoğu zaman ikinci adımı atlıyor ve
 * plakasız müşteri kalıyordu.
 *
 * Kayıt TEK istekle gider (`POST /musteriler`, gövdede `arac`), sunucu
 * ikisini TEK veritabanı işleminde yazar. Frontend'de iki aşamalı kayıt
 * YOK: ikinci istek düşerse plakasız müşteri ortada kalırdı.
 *
 * Günlük kullanımda öncelik sırası PLAKA → AD → TELEFON. İleri araç
 * alanları katlı durur; form mobilde uzayıp kullanılmaz olmasın.
 */
export function MusteriPenceresi({
  mevcut, ilkPlaka = '', kapat, kaydedildi,
}: {
  mevcut?: Musteri; ilkPlaka?: string;
  kapat: () => void; kaydedildi: (id: number) => void;
}) {
  const bildir = useBildirim();
  const git = useNavigate();
  const [ad, setAd] = useState(mevcut?.ad ?? '');
  const [telefon, setTelefon] = useState(mevcut?.telefon ?? '');
  const [eposta, setEposta] = useState(mevcut?.eposta ?? '');
  const [not, setNot] = useState(mevcut?.not ?? '');
  const [bakiye, setBakiye] = useState('');
  const [bakiyeYonu, setBakiyeYonu] = useState('borc');
  /* Araç alanları — yalnızca YENİ müşteride. Düzenleme penceresi eskisi
     gibi kalır; oradaki araçlar müşteri detayından yönetilir. */
  const [plaka, setPlaka] = useState(ilkPlaka);
  const [marka, setMarka] = useState('');
  const [model, setModel] = useState('');
  const [yil, setYil] = useState('');
  const [motor, setMotor] = useState('');
  const [motorKodu, setMotorKodu] = useState('');
  const [sanziman, setSanziman] = useState('');
  const [vin, setVin] = useState('');
  const [aracNot, setAracNot] = useState('');
  /* Plaka çakışmasında sunucu 409 · `PLAKA_VAR:<musteriId>` döndürür;
     kullanıcıya mevcut müşteriyi AÇMA yolu gösterilir. */
  const [cakisanMusteri, setCakisanMusteri] = useState<number | null>(null);

  const { yurut, calisiyor, hata } = useEylem(async () => {
    setCakisanMusteri(null);
    const aracVar = plakaNormalle(plaka).length > 0;
    const govde = {
      ad: ad.trim(), telefon, eposta, not,
      baslangic_bakiye: mevcut ? 0 : Number(bakiye || 0),
      bakiye_yonu: bakiyeYonu,
      ...(mevcut || !aracVar ? {} : {
        arac: {
          plaka, marka, model, motor, motor_kodu: motorKodu, sanziman, vin,
          not: aracNot,
          yil: yil ? Number(yil) : null,
        },
      }),
    };
    try {
      const sonuc = mevcut
        ? await api.guncelle<Musteri>(`/musteriler/${mevcut.id}`, govde)
        : await api.gonder<Musteri>('/musteriler', govde);
      bildir(mevcut ? 'Müşteri güncellendi'
        : aracVar ? 'Müşteri ve aracı eklendi' : 'Müşteri eklendi');
      kaydedildi(sonuc.id);
    } catch (e) {
      const kod = e instanceof ApiHatasi ? (e.kod ?? '') : '';
      if (kod.startsWith('PLAKA_VAR:')) setCakisanMusteri(Number(kod.split(':')[1]));
      throw e;
    }
  });

  return (
    <Pencere
      baslik={mevcut ? 'Müşteriyi düzenle' : 'Yeni müşteri'}
      kapat={kapat}
      altBolum={
        <>
          <button className="btn btn-sade" onClick={kapat} disabled={calisiyor}>Vazgeç</button>
          <button className="btn btn-birincil" onClick={() => void yurut(undefined as never)}
            disabled={calisiyor || !ad.trim()}>
            {calisiyor ? 'Kaydediliyor…' : 'Kaydet'}
          </button>
        </>
      }
    >
      <div className="sutun">
        {/* Yeni kayıtta ilk odak PLAKAYA gider: tezgâhta önce o yazılır. */}
        {!mevcut && (
          <Girdi
            etiket="Plaka" value={plaka} onChange={setPlaka} autoFocus
            duzen="plaka" inputMode="text" placeholder="27 ABC 123"
            ipucu="İsteğe bağlı — girilirse müşteriyle birlikte tek işlemde kaydedilir"
          />
        )}
        <Girdi etiket="Ad soyad" value={ad} onChange={setAd} autoFocus={!!mevcut} required duzen="ozelAd" />
        <div className="izgara izgara-2">
          <Girdi etiket="Telefon" value={telefon} onChange={setTelefon} inputMode="tel" duzen="telefon" />
          <Girdi etiket="E-posta" value={eposta} onChange={setEposta} type="email" duzen="eposta" />
        </div>
        <MetinAlani etiket="Not" value={not} onChange={setNot} rows={3} duzen="cumle" />

        {/* ARAÇ DETAYLARI — katlı. Plaka yukarıda görünür durur; marka,
            model, motor gibi alanlar formu uzatmasın diye buraya alındı.
            Boş bırakılabilir. */}
        {!mevcut && (
          <details className="satir-ek">
            <summary>
              Araç detayları
              <span className="satir-ek-ozet">
                {[marka, model].filter(Boolean).join(' ') || 'isteğe bağlı'}
              </span>
            </summary>
            <div className="sutun" style={{ gap: 'var(--b3)', marginTop: 'var(--b3)' }}>
              <div className="izgara izgara-2">
                <Girdi etiket="Marka" value={marka} onChange={setMarka} duzen="markaModel" placeholder="BMW" />
                <Girdi etiket="Model" value={model} onChange={setModel} duzen="markaModel" placeholder="G20 320i" />
                <Girdi etiket="Yıl" value={yil} onChange={setYil} inputMode="numeric" placeholder="2021" />
                <Girdi etiket="Motor" value={motor} onChange={setMotor} duzen="markaModel" placeholder="2.0 TSI" />
                <Girdi etiket="Motor kodu" value={motorKodu} onChange={setMotorKodu} placeholder="B48" />
                <Girdi etiket="Şanzıman" value={sanziman} onChange={setSanziman} duzen="markaModel" placeholder="Otomatik" />
              </div>
              <Girdi etiket="VIN" value={vin} onChange={setVin} />
              <MetinAlani etiket="Araç notu" value={aracNot} onChange={setAracNot} rows={2} duzen="cumle" />
            </div>
          </details>
        )}
        {!mevcut && (
          <div className="izgara izgara-2">
            <ParaGirdi
              etiket="Başlangıç bakiyesi" deger={bakiye} onChange={setBakiye}
              ipucu="Opsiyonel — devreden tutar"
            />
            <Secim
              etiket="Bakiye yönü" value={bakiyeYonu} onChange={setBakiyeYonu}
              secenekler={[
                { deger: 'borc', ad: 'Alacağım var (+)' },
                { deger: 'alacak', ad: 'Borcum var (−)' },
              ]}
            />
          </div>
        )}
        {hata && (
          <UyariSerit ton="kritik" baslik={cakisanMusteri ? 'Bu plaka zaten kayıtlı' : undefined}>
            {hata}
            {/* Aynı plakayı ikinci kez YARATMAK yerine mevcut kaydı aç. */}
            {cakisanMusteri && (
              <div className="satir" style={{ marginTop: 'var(--b2)' }}>
                <button
                  className="btn btn-kucuk btn-birincil"
                  onClick={() => { kapat(); git(`/musteriler/${cakisanMusteri}`); }}
                >
                  Müşteriyi aç
                </button>
              </div>
            )}
          </UyariSerit>
        )}
      </div>
    </Pencere>
  );
}
